import qs from 'query-string';
import { create } from 'zustand';

import {
    DEFAULT_CURRENT_PAGE, DEFAULT_ORDER_COLUMN, DEFAULT_ORDER_DIRECTION, DEFAULT_PAGE_SIZE, DEFAULT_SEARCH,
} from '@/constants';
import {
    DefaultUsersApiParams, SortDirection,
} from '@/types';

type TableState = {
    orderColumn: DefaultUsersApiParams['order_column'];
    orderDirection: SortDirection;
    currentPage: number;
    pageSize: number;
    search: string;
};

type TableStore = TableState & {
    setOrderColumn: (orderColumn: DefaultUsersApiParams['order_column']) => void;
    setOrderDirection: (orderDirection: SortDirection) => void;
    setCurrentPage: (currentPage: number) => void;
    setPageSize: (pageSize: number) => void;
    setSearch: (search: string) => void;
    reset: () => void;
};

const { search } = window.location;

const parsed = qs.parse(search, {
    parseNumbers: true,
    parseBooleans: false,
});

const initialState: TableState = {
    orderColumn: parsed.order_column as DefaultUsersApiParams['order_column'] || DEFAULT_ORDER_COLUMN,
    orderDirection: parsed.order_direction as SortDirection || DEFAULT_ORDER_DIRECTION,
    currentPage: parsed.current_page as number || DEFAULT_CURRENT_PAGE,
    pageSize: parsed.per_page as number || DEFAULT_PAGE_SIZE,
    search: parsed.search as string || DEFAULT_SEARCH,
};

export const useTableStore = create<TableStore>((set) => ({
    ...initialState,

    setOrderColumn: (orderColumn: DefaultUsersApiParams['order_column']) => set({ orderColumn, currentPage: DEFAULT_CURRENT_PAGE }),
    setOrderDirection: (orderDirection: SortDirection) => set({ orderDirection, currentPage: DEFAULT_CURRENT_PAGE }),
    setCurrentPage: (currentPage: number) => set({ currentPage }),
    setPageSize: (pageSize: number) => set({ pageSize, currentPage: DEFAULT_CURRENT_PAGE }),
    setSearch: (search: string) => set({ search, currentPage: DEFAULT_CURRENT_PAGE }),

    reset: () => set({
        orderColumn: DEFAULT_ORDER_COLUMN,
        orderDirection: DEFAULT_ORDER_DIRECTION,
        currentPage: DEFAULT_CURRENT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
        search: DEFAULT_SEARCH,
    }),
}));
